import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoTariffListCurrencyCellProps
  extends CellContext<TariffModel, TariffModel['currency']> {}

export const EmspBoTariffListCurrencyCell = (
  props: EmspBoTariffListCurrencyCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  return <Text truncate>{getValue()}</Text>;
};
